// extracted by mini-css-extract-plugin
export var avatar = "comments-module--avatar--e858d";
export var body = "comments-module--body--13fee";
export var comment = "comments-module--comment--d1dd0";
export var date = "comments-module--date--f9a81";
export var form = "comments-module--form--f563b";
export var list = "comments-module--list--39ecc";
export var name = "comments-module--name--eae38";
export var reply = "comments-module--reply--7ad82";
export var root = "comments-module--root--f60b6";
export var show = "comments-module--show--a63d9";
export var wrapper = "comments-module--wrapper--8e095";